import {
  LOAD_SUCCESS_QUALITES,
  LOAD_FAIL_QUALITES,
  SAVE_SUCCESS_QUALITES,
  SAVE_FAIL_QUALITES,
  UPDATE_SUCCESS_QUALITES,
  UPDATE_FAIL_QUALITES,
  DELETE_SUCCESS_QUALITES,
  DELETE_FAIL_QUALITES,
} from "../actions/qualiteAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_QUALITES:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_QUALITES:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_QUALITES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_QUALITES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_QUALITES:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.code_couleur_id === action.payload.code_couleur_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_QUALITES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_QUALITES:
      const filtered = state.data.filter((item) => {
        return item.code_couleur_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_QUALITES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
